<template>
	<el-main>
		<el-row>
			<el-col :lg="4" :xl="4">
				<div class="hidden-md-and-down">&nbsp;</div>
			</el-col>
			<el-col :xs="24" :sm="24" :md="24" :lg="14" :xl="14">
				<div class="price-side hidden-lg-and-up">
					<div class="calculator">
						<div class="total">
							<h3>消费统计</h3>
							<h4>￥<span>{{totalDay | priceFloat}}</span>/天（合￥<span>{{totalMonth | priceFloat}}</span>/月）</h4>
						</div>
						<div class="btn-area">
							<a @click="resetTotal()">清空</a>
						</div>
					</div>
				</div>
				<div class="price-body">
					<div class="plan" v-for="(value, key,index1) in prices" :key="key">
						<el-row>
							<el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12">
								<div class="name">
									<h3><span></span>{{key}}</h3>
								</div>
							</el-col>
							<el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12">
								<div class="price" v-if="key=='Traffic'">￥<span>{{cost[index1]?cost[index1]:0 | priceFloat}}</span>/10M&nbsp;&nbsp;</div>
								<div class="price" v-else>￥<span>{{cost[index1]?cost[index1]:0 | priceFloat}}</span>/天（合￥{{cost[index1]?cost[index1]*30:0 | priceFloat}}/月）</div>
							</el-col>
						</el-row>
						<div class="option-area">
							<div :class="actives[index1] == index ? 'option active':'option'" v-for="(item,index) in value" :key="item.hexId"
							 @click="selectPlan(index1,index,item)">{{item.name}}</div>
						</div>
					</div>
				</div>
			</el-col>
			<el-col :lg="6" :xl="6">
				<div class="price-side hidden-md-and-down">
					<div class="calculator">
						<div class="total">
							<h3>消费统计</h3>
							<h4>￥<span>{{totalDay | priceFloat}}</span>/天（合￥<span>{{totalMonth | priceFloat}}</span>/月）</h4>
						</div>
						<div class="detail">
							<div class="item" v-for="(value, key, index) in prices" :key="index" v-if="key != 'Traffic'">
								<span class="left">{{key}}<span>{{actives[index] != undefined ? '('+value[actives[index]].name+')':''}}</span></span><span
								 class="right">￥<span>{{actives[index] != undefined ? value[actives[index]].price:0 | priceFloat}}</span>/天</span>
							</div>
						</div>
						<div class="btn-area">
							<a @click="resetTotal()">清空</a>
						</div>
					</div>
				</div>
			</el-col>
			</el-col>
		</el-row>
	</el-main>
</template>

<script>
	export default {
		name: 'Price',
		components: {},
		data() {
			return {
				prices: {},
				actives: [],
				cost: []
			}
		},
		created: function() {
			this.getPrices();
		},
		computed: {
			totalDay() {
				let total = 0;
				for (let i = 0; i < this.cost.length; i++) {
					if (i == 1 || this.cost[i] == undefined) {
						continue;
					}
					total += this.cost[i];
				}
				return total;
			},
			totalMonth() {
				let total = 0;
				for (let i = 0; i < this.cost.length; i++) {
					if (i == 1 || this.cost[i] == undefined) {
						continue;
					}
					total += this.cost[i] * 30;
				}
				return total;
			}
		},
		methods: {
			getPrices() {
				this.$axios.post('/price').then((res) => {
					res = res.data;
					this.prices = res.pricing;
					this.$set(this.actives, 0, 0);
					this.$set(this.cost, 0, this.prices['Memory'][0].price)
				}).catch((err) => {
					console.log(err)
				})
			},
			selectPlan(index1, index, item) {
				this.$set(this.actives, index1, index);
				this.$set(this.cost, index1, item.price)
			},
			resetTotal() {
				this.actives = [];
				this.cost = [];
				this.$set(this.actives, 0, 0);
				this.$set(this.cost, 0, this.prices['Memory'][0].price)
			}
		}

	}
</script>

<style>
	@media (min-width:992px) {
		.price-body {
			margin: 140px 0;
			font-family: "microsoft yahei";
		}

		.price-body .plan {
			width: 780px;
		}

		.price-body .plan:not(:first-child) {
			margin-top: 15px;
		}

		.price-body .plan .name,
		.price-body .plan .price {
			width: 100%;
			text-align: left;
		}

		.price-body .plan .name h3 {
			font-size: 18px;
			color: #333;
			font-weight: 500;
		}

		.price-body .plan .name h3 span {
			width: 3px;
			height: 18px;
			background-color: #3da8e2;
			display: inline-block;
			margin-right: 10px;
		}

		.price-body .plan .price {
			font-size: 14px;
			color: #333;
		}

		.price-body .plan .price span {
			color: #349ce3;
			font-size: 18px;
		}

		.price-body .plan .option-area {
			width: 100%;
			margin-top: 10px;
			display: flex;
			flex-flow: row wrap;
			justify-content: flex-start;
		}

		.price-body .plan .option-area .option {
			margin: 0 0 10px -1px;
			width: 126.5px;
			height: 36px;
			display: flex;
			justify-content: center;
			align-items: center;
			border: 1px solid #349ce3;
			color: #333;
			font-size: 14px;
		}

		.price-body .plan .option-area .option.active {
			background-color: #e8f6ff;
			color: #349ce3;
		}

		.price-side {
			margin-top: 140px;
			background-color: #25A5FF;
			position: fixed;
			font-family: "microsoft yahei";
		}

		.price-side .calculator {
			width: 330px;
			height: 500px;
			background-color: #1F2F3D;
		}

		.price-side .calculator .total {
			height: 50px;
			background-color: #349ce3;
			padding: 15px 0;
			text-align: center;
			color: #ffffff;
		}

		.price-side .calculator .total h3,
		.price-side .calculator .total span {
			font-size: 22px;
		}

		.price-side .calculator .total h4 {
			font-size: 18px;
			line-height: 1.2;
		}

		.price-side .calculator .detail {
			height: 350px;
			background-color: #e8f6ff;
			overflow-y: scroll;
		}

		.price-side .calculator .detail .item {
			height: 18px;
			padding: 10px;
			color: #333;
		}

		.price-side .calculator .detail .item span.left {
			font-size: 13px;
			float: left;
			font-weight: 400;
		}

		.price-side .calculator .detail .item span.right {
			font-size: 13px;
			float: right;
			font-weight: 400;
		}

		.price-side .calculator .btn-area {
			height: 52px;
			border-top: 1px solid #c9eaff;
			background-color: #e8f6ff;
			padding-top: 18px;
			text-align: center;
		}

		.price-side .calculator .btn-area a {
			width: 105px;
			height: 28px;
			padding: 3px;
			font-size: 20px;
			background-color: #349ce3;
			display: block;
			margin: 0 auto;
			border-radius: 2px;
			display: flex;
			justify-content: center;
			align-items: center;
		}
	}

	@media (max-width:992px) {
		.price-body {
			margin: 140px 0 40px;
			font-family: "microsoft yahei";
			display: flex;
			flex-direction: column;
			justify-content: center;
			align-items: center;
		}

		.price-body .plan {
			width: 95%;
		}

		.price-body .plan:not(:first-child) {
			margin-top: 15px;
		}

		.price-body .plan .name {
			width: 100%;
			text-align: left;
		}

		.price-body .plan .price {
			width: 100%;
			text-align: right;
		}

		.price-body .plan .name h3 {
			font-size: 16px;
			color: #333;
			font-weight: 600;
		}

		.price-body .plan .name h3 span {
			width: 3px;
			height: 16px;
			background-color: #3da8e2;
			display: inline-block;
			margin-right: 10px;
		}

		.price-body .plan .price {
			font-size: 12px;
			color: #333;
		}

		.price-body .plan .price span {
			color: #349ce3;
			font-size: 14px;
			font-weight: 600;
		}

		.price-body .plan .option-area {
			width: 100%;
			margin-top: 10px;
			display: flex;
			flex-flow: row wrap;
			justify-content: flex-start;
		}

		.price-body .plan .option-area .option {
			font-family: tahoma, arial, "Hiragino Sans GB", "微软雅黑", simsun, sans-serif;
			margin: 0 0 5px -1px;
			width: 24%;
			height: 36px;
			display: flex;
			justify-content: center;
			align-items: center;
			border: 1px solid #67CAF7;
			color: #333;
			font-size: 12px;
		}

		.price-body .plan .option-area .option.active {
			background-color: #e8f6ff;
			font-weight: 600;
		}

		.price-side {
			z-index: 500;
			position: fixed;
			font-family: "microsoft yahei";
			display: flex;
			justify-content: center;
			width: 100%;
		}

		.price-side .calculator {
			width: 96%;
			height: 120px;
		}

		.price-side .calculator .total {
			height: 50px;
			background-color: #349ce3;
			padding: 10px 0;
			text-align: center;
			color: #ffffff;
		}

		.price-side .calculator .total h3,
		.price-side .calculator .total span {
			font-size: 18px;
		}

		.price-side .calculator .total h4 {
			font-size: 16px;
			line-height: 1.2;
		}

		.price-side .calculator .btn-area {
			height: 50px;
			border-top: 1px solid #c9eaff;
			background-color: #e8f6ff;
			display: flex;
			flex-direction: row;
			justify-content: center;
			align-items: center;
		}

		.price-side .calculator .btn-area a {
			width: 65px;
			height: 18px;
			padding: 3px;
			font-size: 16px;
			background-color: #349ce3;
			display: block;
			margin: 0 auto;
			border-radius: 2px;
			display: flex;
			justify-content: center;
			align-items: center;
		}
	}
</style>
<style></style>


// WEBPACK FOOTER //
// src/components/Price.vue